import {matchPath} from 'react-router'

export function checkIsActive(pathname: string, url: string) {
  return Boolean(
    matchPath(pathname, {
      path: url,
    })
  )
}
